import { useCallback } from 'react';

interface ToastOptions {
  title: string;
  description: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const toast = useCallback(({ title, description, variant = 'default' }: ToastOptions) => {
    // For now, just log to console since we don't have a toast component yet
    console.log(`[${variant.toUpperCase()}] ${title}: ${description}`);
  }, []);

  return { toast };
}
